'use strict';

/**
 * NavigationFlyout
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
T.Module.NavigationFlyout = T.createModule({

	_selectors: {
		button: '[data-js-a-navigation-button]',
		overlay: '[data-js-m-navigation-flyout__overlay]',
		title: '[data-js-m-navigation-flyout__title]',
		navigationButtons: '.a-navigation-button',
		sheet: '[data-js-m-navigation-flyout__sheet]',
		back: '.m-navigation-flyout__back',
		activeLink: '.state-active[data-js-m-navigation-flyout__link]',
		bodyHtml: 'body, html',
		link: '[data-js-m-navigation-flyout__link]',
		fadeArrow: '[data-js-m-navigation-flyout__fade-arrow]',
		wrapper: '[data-js-m-navigation-flyout__sheet-wrapper]',
		fade: '[data-js-m-navigation-flyout__fade]',
		html: 'html, body'
	},

	_classes: {
		link: 'm-navigation-flyout__link',
		back: 'm-navigation-flyout__back',
		idPrefix: 'id-',
		sheetPrefix: 'sheet-',
		levelPrefix: 'level-',
		initialLevel: 'level-1'
	},

	_eventNames: {
		toggle: 'navigation-flyout-toggle',
		close: 'navigation-button-close'
	},

	_stateClasses: {
		open: 'state-open',
		closed: 'state-closed',
		currentSheet: 'state-current',
		belowSheet: 'state-below',
		outSheet: 'state-out',
		activeLink: 'state-active',
		hasLinks: 'state-has-links',
		reverse: 'state-reverse',
		initiallyOpen: 'state-initially-open',
		fadeMore: 'state-more',
		justOpened: 'state-just-opened',
		closing: 'state-closing',
		neverOpened: 'state-never-opened'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		this.$buttons = this.$ctx.parent().find(this._selectors.button);
		this.$overlay = this.$ctx.find(this._selectors.overlay);
		this.$links = this.$ctx.find(this._selectors.link);
		this.$back = this.$ctx.find(this._selectors.back);
		this.$activeLink = this.$ctx.find(this._selectors.activeLink);
		this.$sheetWrappers = this.$ctx.find(this._selectors.wrapper);
		this.$fade = this.$ctx.find(this._selectors.fade);
		this.$sheets = this.$ctx.find(this._selectors.sheet);

		this.$links.click(this.$onLinkClicked.bind(this));
		// use jQuery hoverDelay (see pattern readme)
		this.$links.hoverDelay({
			over: this.$onLinkHovered.bind(this),
			delayOver: 750,
			delayOut: 0
		});

		this.$back.click(this.$onBackClicked.bind(this));
		this.$fade.click(this.$onFadeClicked.bind(this));
		this.$sheets.scroll(this.$onSheetScrolled.bind(this));

		this._events.on(this._eventNames.toggle, this.toggle.bind(this));

		$(document).keyup(this.$onKeyUp.bind(this));
		$(document).mouseup(this.$onMouseUp.bind(this));
		$(window).resize(this.updateSheetsFadeEffect.bind(this));

		this.$ctx.addClass(this._classes.initialLevel);
		this.addActiveClassesInitially();

		resolve();
	},


	/**
  * Opens or closes the flyout by setting the appropriate state classes.
  *
  * @returns {void}
  */
	toggle: function toggle() {
		if (this.$ctx.hasClass(this._stateClasses.open)) {
			this.closeFlyout();
		} else {
			this.openFlyout();
		}
	},


	/**
  * Opens the flyout.
  *
  * @returns {void}
  */
	openFlyout: function openFlyout() {
		if (this.$ctx.hasClass(this._stateClasses.neverOpened)) {
			this.$ctx.removeClass(this._stateClasses.neverOpened);
		}
		this.$ctx.removeClass(this._stateClasses.closed);
		this.$ctx.addClass(this._stateClasses.open);
		this.$ctx.removeClass(this._stateClasses.closing);
		this.$ctx.addClass(this._stateClasses.justOpened);
		this.updateSheetsFadeEffect();

		// Do not allow scrolling when the navigation is open.
		$(this._selectors.html).css({
			'overflow': 'hidden',
			'height': '100%'
		});
	},


	/**
  * Closes the flyout.
  *
  * @returns {void}
  */
	closeFlyout: function closeFlyout() {
		this.$ctx.addClass(this._stateClasses.closed);
		this.$ctx.removeClass(this._stateClasses.open);
		this.$ctx.addClass(this._stateClasses.closing);

		$(this._selectors.html).removeAttr('style');
	},


	/**
  * Checks whether target is outside of element.
  *
  * @param {Object} $element A jQuery element.
  * @param {Object} target A native click event target.
  * @returns {boolean} Is the click outside?
     */
	isClickOutSideOf: function isClickOutSideOf($element, target) {
		return !$element.is(target) && $element.has(target).length === 0;
	},


	/**
  * Checks whether target is inside of element.
  *
  * @param {Object} $element A jQuery element.
  * @param {Object} target A native click event target.
  * @returns {boolean} Is the click inside?
     */
	isClickInSideOf: function isClickInSideOf($element, target) {
		return $element.is(target);
	},


	/**
  * Handles when a key is pressed. In case escape is pressed, the flyout will be closed.
  *
  * @param {Object} event The native click event.
  * @returns {void}
     */
	$onKeyUp: function $onKeyUp(event) {
		if (event.keyCode === 27 && this.$ctx.hasClass(this._stateClasses.open)) {
			this._events.emit(this._eventNames.close, 'anonymous');
		}
	},


	/**
  * Handles a mouse click and closes the flyout, if an outside area was clicked.
  *
  * @param {Object} event The native click event.
  * @returns {void}
     */
	$onMouseUp: function $onMouseUp(event) {
		if (this.$ctx.hasClass(this._stateClasses.open) && (this.isClickOutSideOf(this.$ctx, event.target) || this.isClickInSideOf(this.$overlay, event.target)) && this.isClickOutSideOf(this.$buttons, event.target)) {
			this._events.emit(this._eventNames.close, 'anonymous');
		}
	},


	/**
  * Handles a click on a link.
  *
  * @param {Object} event The native click event.
  * @returns {void}
     */
	$onLinkClicked: function $onLinkClicked(event) {
		var $eventTarget = $(event.target);
		var $link = $eventTarget.closest(this._selectors.link);

		if (!this.hasChildSheet($eventTarget, $link)) {
			event.stopPropagation();
			this.openLinkIfIsLink($eventTarget);
			// Default link behaviour
			return;
		}

		event.preventDefault();
		event.stopPropagation();

		this.adaptActiveLinkClasses($link);
		this.removeInitiallyOpenClass();

		this.$ctx.removeClass(this._stateClasses.back);

		this.adaptSheetsAfterLinkClick($link);
	},


	/**
  * Handles a hover on a link.
  *
  * @param {Object} event The native hover event.
  * @returns {void}
     */
	$onLinkHovered: function $onLinkHovered(event) {
		var $eventTarget = $(event.target);
		var $link = $eventTarget.closest(this._selectors.link);

		if (!this.hasChildSheet($eventTarget, $link)) {
			event.stopPropagation();
			return;
		}

		event.preventDefault();
		event.stopPropagation();

		this.adaptActiveLinkClasses($link);
		this.removeInitiallyOpenClass();

		this.$ctx.removeClass(this._stateClasses.back);

		this.adaptSheetsAfterLinkClick($link);
	},


	/**
  * Returns true if the link has a child sheet that should be opened.
  *
  * @param {Object} $eventTarget The click target as a jQuery object.
  * @param {Object} $link The nearest link upwards if there is one.
  * @returns {boolean} Is there a child sheet?
  */
	hasChildSheet: function hasChildSheet($eventTarget, $link) {
		// Default behaviour for back button and title link.
		if (this.isBackButton($eventTarget) || this.isTitleLink($eventTarget)) {
			return false;
		}

		return this.hasLinks($link);
	},


	/**
  * Checks if the element pressed is a back button.
  *
  * @param {Object} $target The jQuery object of the native click event target.
  * @returns {boolean} Is it a back button?
     */
	isBackButton: function isBackButton($target) {
		return $target.hasClass(this._classes.back) || $target.parent().hasClass(this._classes.back) || $target.parent().parent().hasClass(this._classes.back);
	},


	/**
  * Checks whether the link clicked was a sheet title which should be treated as if it were a normal link.
  *
  * @param {Object} $target The jQuery object of the native click event target.
  * @returns {boolean} Was it a sheet title?
  */
	isTitleLink: function isTitleLink($target) {
		return $target.hasAttr(this._selectors.title) || $target.parent().hasAttr(this._selectors.title) || $target.parent().parent().hasAttr(this._selectors.title);
	},


	/**
  * Checks if the link supplied has further links, which is signified by having the has-links state class.
  *
  * @param {Object} $link The jQuery object of the link.
  * @returns {boolean} Does the link have sub links?
     */
	hasLinks: function hasLinks($link) {
		return $link.hasClass(this._stateClasses.hasLinks) || $link.parent().hasClass(this._stateClasses.hasLinks);
	},


	/**
  * If the area around a link was clicked, the link inside should be opened.
  *
  * @param {Object} $eventTarget A jQuery object of the link clicked.
  * @returns {void} On the link the click event will be triggered, if it was a link.
     */
	openLinkIfIsLink: function openLinkIfIsLink($eventTarget) {
		if ($eventTarget.hasAttr(this._selectors.link)) {
			$eventTarget.find('a span').trigger('click');
		}
	},


	/**
  * Adapts the sheet states after a link was clicked.
  *
  * @param {Object} $link The link.
  * @returns {void}
     */
	adaptSheetsAfterLinkClick: function adaptSheetsAfterLinkClick($link) {
		var $nextSheetWrapper = $link.find(this._selectors.wrapper).first();
		var $currentSheetWrapper = $link.parent().parent();

		if ($currentSheetWrapper.hasClass(this._stateClasses.belowSheet)) {
			this.resetSheetStates($currentSheetWrapper);
		}

		this.addSheetLevelToComponent($nextSheetWrapper);
		this.removeReverseClasses();

		$nextSheetWrapper.removeClass(this._stateClasses.outSheet);
		$nextSheetWrapper.addClass(this._stateClasses.currentSheet);

		$currentSheetWrapper.addClass(this._stateClasses.belowSheet);

		if ($currentSheetWrapper.hasClass(this._stateClasses.currentSheet)) {
			$currentSheetWrapper.removeClass(this._stateClasses.currentSheet);
		}

		this.updateSheetFadeScrolling($nextSheetWrapper);
	},


	/**
  * Handles a click on the back arrow icon, by adjusting sheet states accordingly.
  *
  * @param {Object} event The native click event.
  * @returns {void}
     */
	$onBackClicked: function $onBackClicked(event) {
		var $eventTarget = $(event.target);

		this.removeInitiallyOpenClass();
		this.updateSheetsFadeEffect();

		var $currentSheetWrapper = $eventTarget.closest(this._selectors.wrapper);

		this.removeActiveLinksFrom($currentSheetWrapper);

		// In case back was clicked on a sheet way below the current sheet adapt it (e.g. when clicking
		// back on desktop for level-5.)
		if (!$currentSheetWrapper.hasClass(this._stateClasses.currentSheet)) {
			$currentSheetWrapper = $currentSheetWrapper.find('.' + this._stateClasses.currentSheet);
		}

		var $nextSheetWrapper = $currentSheetWrapper.parents(this._selectors.wrapper).first();
		var $beforeSheetWrapper = $currentSheetWrapper.find(this._selectors.wrapper).first();

		$beforeSheetWrapper.removeClass(this._stateClasses.out);

		if ($currentSheetWrapper.hasClass(this._stateClasses.belowSheet)) {
			this.resetSheetStates($currentSheetWrapper);
		}

		this.addSheetLevelToComponent($nextSheetWrapper);

		$currentSheetWrapper.addClass(this._stateClasses.outSheet);
		$currentSheetWrapper.removeClass(this._stateClasses.currentSheet);

		$nextSheetWrapper.addClass(this._stateClasses.currentSheet);
		$nextSheetWrapper.removeClass(this._stateClasses.belowSheet);

		this.addReverseClasses($currentSheetWrapper);

		this.updateSheetFadeScrolling($nextSheetWrapper);
	},


	/**
  * Adds the level of the sheet to the component top element, for easier targeting by CSS.
  *
  * @param {Object} $sheetWrapper The sheet.
  * @returns {void}
     */
	addSheetLevelToComponent: function addSheetLevelToComponent($sheetWrapper) {
		var newLevelClass = this.getLevelClass($sheetWrapper);
		var oldLevelClass = this.getLevelClass(this.$ctx);

		// If they are the same, it's possible that the class is removed altogether. Order of statements does not matter.
		if (oldLevelClass !== newLevelClass) {
			this.$ctx.addClass(newLevelClass);
			this.$ctx.removeClass(oldLevelClass);
		}
	},


	/**
  * Returns the level class of a sheet wrapper. level-*
  *
  * @param {Object} $sheetWrapper A sheet wrapper
  * @returns {string} The level class.
     */
	getLevelClass: function getLevelClass($sheetWrapper) {
		var _this = this;

		var classes = $sheetWrapper.attr('class');
		return $.grep(classes.split(' '), function (item) {
			return item.indexOf(_this._classes.levelPrefix) === 0;
		}).join();
	},


	/**
  * When the navigation opens the active links and their sheets get the appropriate state classes. Starts at the
  * lowest active link and moves up.
  *
  * @returns {void}
  */
	addActiveClassesInitially: function addActiveClassesInitially() {
		if (this.$activeLink.length > 0) {
			var $link = this.$activeLink.last();
			var $sheetWrapper = $link.closest(this._selectors.wrapper);
			// The link contains further links and which should be displayed initially.
			if ($link.hasClass(this._stateClasses.hasLinks)) {
				$sheetWrapper = this.activateTitleAndGetWrapperSheet($link);
			}
			this.markSheetsWithInitialStateClasses($sheetWrapper);
		}
	},


	/**
  * Adds the active class to the title and returns the wrapper of it's sheet.
  *
  * @param {Object} $link A jQuery object of the link.
  * @returns {Object} The wrapper.
     */
	activateTitleAndGetWrapperSheet: function activateTitleAndGetWrapperSheet($link) {
		var $title = $link.find(this._selectors.title).first();
		$title.addClass(this._stateClasses.activeLink);
		return $title.closest(this._selectors.wrapper);
	},


	/**
  * Add the active class to the link, but remove it from descendants. Do the same for the links sibling paths as well.
  *
  * @param {Object} $link The jQuery link object.
  * @returns {void}
     */
	adaptActiveLinkClasses: function adaptActiveLinkClasses($link) {
		var $siblings = $link.siblings(this._selectors.activeLink);
		this.removeActiveLinkChildren($link);
		$link.addClass(this._stateClasses.activeLink);
		this.removeActiveLinkChildren($siblings);
	},


	/**
  * After back was clicked all the active links starting from the new sheet should be removed.
  *
  * @param {Object} $currentSheetWrapper The jQuery object of a sheet wrapper.
  * @returns {void}
     */
	removeActiveLinksFrom: function removeActiveLinksFrom($currentSheetWrapper) {
		var $nextSheetWrapper = $currentSheetWrapper.parents(this._selectors.wrapper).first();
		$nextSheetWrapper.find(this._selectors.activeLink).removeClass(this._stateClasses.activeLink);
	},


	/**
  * Remove active link classes below the passed link.
  *
  * @param {Object} $link The jQuery link object.
  * @returns {void}
     */
	removeActiveLinkChildren: function removeActiveLinkChildren($link) {
		$link.removeClass(this._stateClasses.activeLink);
		$link.find(this._selectors.activeLink).removeClass(this._stateClasses.activeLink);
	},


	/**
  * Adds the initial state classes to the wrapper sheets from bottom to top.
  *
  * @param {Object} $sheetWrapper The sheet
  * @returns {void}
     */
	markSheetsWithInitialStateClasses: function markSheetsWithInitialStateClasses($sheetWrapper) {
		var currentStateClassAssigned = false;
		this.removeLevelClassFromComponent();

		do {
			if (!currentStateClassAssigned) {
				this.$ctx.addClass(this.getLevelClass($sheetWrapper));
				$sheetWrapper.addClass(this._stateClasses.initiallyOpen);
				$sheetWrapper.addClass(this._stateClasses.currentSheet);
				currentStateClassAssigned = true;
			} else {
				$sheetWrapper.addClass(this._stateClasses.belowSheet);
			}
			$sheetWrapper = $sheetWrapper.parents(this._selectors.wrapper).first();
		} while ($sheetWrapper.length > 0);
	},


	/**
  * Removes all initially open state classes.
  *
  * @returns {void}
  */
	removeInitiallyOpenClass: function removeInitiallyOpenClass() {
		this.$ctx.removeClass(this._stateClasses.justOpened);
		this.$ctx.removeClass(this._stateClasses.closing);
		this.$ctx.find('.' + this._stateClasses.initiallyOpen).removeClass(this._stateClasses.initiallyOpen);
	},


	/**
  * Removes the level-* class from the component.
  *
  * @returns {void}
  */
	removeLevelClassFromComponent: function removeLevelClassFromComponent() {
		var _this2 = this;

		var classes = this.$ctx.attr('class').split(' ').filter(function (classString) {
			return classString.lastIndexOf(_this2._classes.levelPrefix, 0) !== 0;
		});

		this.$ctx.attr('class', $.trim(classes.join(' ')));
	},


	/**
  * Hides this sheet and all of it's children.
  *
  * @param {Object} $sheetWrapper The sheet.
  * @returns {void}
  */
	resetSheetStates: function resetSheetStates($sheetWrapper) {
		var childSheetWrappers = $sheetWrapper.find(this._selectors.wrapper);

		$sheetWrapper.removeClass(this._stateClasses.belowSheet);

		childSheetWrappers.removeClass(this._stateClasses.belowSheet);
		childSheetWrappers.removeClass(this._stateClasses.currentSheet);
	},


	/**
  * When back is clicked we want the animations to be backwards. Therefore adding a state class.
  *
  * @param {Object} $sheetWrapper A jQuery object representing the wrapper.
  * @returns {void}
     */
	addReverseClasses: function addReverseClasses($sheetWrapper) {
		do {
			if ($sheetWrapper.hasAttr(this._selectors.wrapper)) {
				$sheetWrapper.addClass(this._stateClasses.reverse);
			}
			$sheetWrapper = $sheetWrapper.parents(this._selectors.wrapper).first();
		} while ($sheetWrapper.length > 0);
	},


	/**
  * Remove the reverse classes indicating the animations should be backwards, due to back link clicked.
  * This function is called every time a link in the naviation is clicked.
  *
  * @returns {void}
  */
	removeReverseClasses: function removeReverseClasses() {
		this.$ctx.find('.' + this._stateClasses.reverse).removeClass(this._stateClasses.reverse);
	},


	/**
  * After the sheet has been scrolled, check if the fade should still be shown. Adapt state classes accordingly.
  *
  * @param {Object} event The native scroll event.
  * @returns {void}
     */
	$onSheetScrolled: function $onSheetScrolled(event) {
		var sheet = event.target;
		var $sheetWrapper = $(sheet).parent(this._selectors.wrapper);

		this.checkSheetScrollPositionAndAdaptFadeState(sheet, $sheetWrapper);
	},


	/**
  * Update the fade effects of all currently visible sheets.
  *
  * @returns {void}
  */
	updateSheetsFadeEffect: function updateSheetsFadeEffect() {
		var _this3 = this;

		this.$sheets.each(function (index, sheet) {
			sheet.scrollTop = 0;
		});

		this.$sheetWrappers.each(function (index, sheetWrapper) {
			var $sheetWrapper = $(sheetWrapper);
			_this3.updateSheetFadeScrolling($sheetWrapper);
		});
	},


	/**
  * When a new sheet that was hidden before enters the viewport a check if a fade is necessary is performed.
  *
  * @param {Object} $sheetWrapper A sheet wrapper jQuery object.
  * @returns {void}
     */
	updateSheetFadeScrolling: function updateSheetFadeScrolling($sheetWrapper) {
		var $sheet = $sheetWrapper.find(this._selectors.sheet).first();
		var sheet = $sheet.get(0);

		sheet.scrollTop = 0;

		this.checkSheetScrollPositionAndAdaptFadeState(sheet, $sheetWrapper);
	},


	/**
  * Checks the current scroll position of the sheet and shows or hides the fade effect.
  *
  * @param {Object} sheet A dom object representing the sheet.
  * @param {Object} $sheetWrapper A jQuery object representing the sheet's wrapper.
  * @returns {void}
     */
	checkSheetScrollPositionAndAdaptFadeState: function checkSheetScrollPositionAndAdaptFadeState(sheet, $sheetWrapper) {
		if (sheet.clientHeight + sheet.scrollTop > sheet.scrollHeight - 30) {
			$sheetWrapper.removeClass(this._stateClasses.fadeMore);
		} else if (!$sheetWrapper.hasClass(this._stateClasses.fadeMore)) {
			$sheetWrapper.addClass(this._stateClasses.fadeMore);
		}
	},


	/**
  * Triggered when the fade arrow is clicked, will scroll down by 100px.
  *
  * @param {Object} event The native click event.
  * @returns {void}
     */
	$onFadeClicked: function $onFadeClicked(event) {
		var $target = $(event.target);
		var $fade = $target.closest(this._selectors.fade);
		var $sheet = $fade.prev();

		event.preventDefault();
		event.stopPropagation();

		$sheet.animate({ scrollTop: $sheet.scrollTop() + 100 }, 180);
	}
});